import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
}

export default function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
  }, [title, description, keywords]);
}